import script from "./icon-call.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-call.vue?vue&type=script&lang=ts&setup=true"

import "./icon-call.vue?vue&type=style&index=0&id=42f8e588&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f8e588"]])

export default __exports__